import { render, staticRenderFns } from "./ColorPalleteThumbnail.vue?vue&type=template&id=2341be54"
import script from "./ColorPalleteThumbnail.vue?vue&type=script&lang=js"
export * from "./ColorPalleteThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports